import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { logoutUser, notifyAuthChanged } from "../../auth";

const navItems = [
  { id: "admin-dashboard", label: "Dashboard", icon: "la la-home", key: "dashboard", to: "/admin-dashboard" },
  { id: "admin-jobs", label: "Manage Jobs", icon: "la la-briefcase", key: "jobs", to: "/admin-jobs" },
  { id: "admin-post-job", label: "Post a Job", icon: "la la-plus-circle", key: "post-job", to: "/admin-post-job" },
  { id: "admin-employers", label: "Employers", icon: "la la-building", key: "employers", to: "/admin-employers" },
  { id: "admin-candidates", label: "Candidates", icon: "la la-users", key: "candidates", to: "/admin-candidates" },
  { id: "admin-applications", label: "Applications", icon: "la la-file-invoice", key: "applications", to: "/admin-applications" },
  { id: "admin-audit", label: "Audit Logs", icon: "la la-history", key: "audit", to: "/admin-audit-logs" },
  { id: "admin-contact-messages", label: "Messages", icon: "la la-envelope", key: "messages", to: "/admin-contact-messages" },
  { id: "admin-payments", label: "Payments", icon: "la la-credit-card", key: "payments", to: "/admin-payments" },
  { id: "admin-billing-customers", label: "Billing Customers", icon: "la la-user-tag", key: "billing-customers", to: "/admin-billing-customers" },
  { id: "admin-settings", label: "Settings", icon: "la la-cog", key: "settings", to: "/admin-settings" },
  { id: "admin-profile", label: "Admin Profile", icon: "la la-user", key: "profile", to: "/admin-profile" },
  { id: "admin-logout", label: "Logout", icon: "la la-sign-out", to: "/" },
];

const AdminSidebar = ({ active = "dashboard", onClose }) => {
  const navigate = useNavigate();

  const handleLogout = async (e) => {
    e.preventDefault();
    await logoutUser({ notify: false });
    onClose?.();
    navigate("/login", { replace: true });
    notifyAuthChanged();
  };

  return (
    <div className="user-sidebar">
      <div className="sidebar-inner">
        <div className="admin-sidebar-head">
          <div>
            <h4>Admin Menu</h4>
            <span>Monitor platform activity</span>
          </div>
          <button type="button" onClick={onClose} aria-label="Close admin menu">
            &times;
          </button>
        </div>

        <ul className="navigation">
          {navItems.map((item) => (
            <li className={item.key === active ? "active" : ""} key={item.id}>
              <Link to={item.to || "/admin-dashboard"} onClick={item.id === "admin-logout" ? handleLogout : onClose}>
                <i className={item.icon}></i>
                {item.label}
              </Link>
            </li>
          ))}
        </ul>

        <div className="admin-sidebar-note">
          <h4>Admin Focus</h4>
          <p>Keep jobs, employers, applications, and payments easy to audit.</p>
        </div>
      </div>
    </div>
  );
};

export default AdminSidebar;
